<template>
  <div class="tabsbar">
    <div class="box">
      <router-link tag="div" to="/">
        <img src="../assets/imgapp/tab1.png" alt=""
      />
    </router-link>
      <div>
        <a href="tel:+86 571-28828888"
          ><img src="../assets/imgapp/tab2.png" alt=""
        /></a>
      </div>
      <router-link tag="div" to="/leaveMsg"
        ><img src="../assets/imgapp/tab3.png" alt=""
      /></router-link>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style  scoped>
.box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 98px;
  background: linear-gradient(270deg, #1e88f0 0%, #4a47ff 100%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 47;
}
.box > div img {
  width: 46px;
  height: 46px;
}
</style>